import React from "react";
import BackToHome from "../components/BackToHome";

export default function Terms() {
  return (
    <main className="legal container pad">
      <BackToHome />
      <h1>利用規約</h1>

      <p>
        本利用規約（以下「本規約」）は、個人事業「ベースボール」（代表：大倉恭弘、以下「当オフィス」）が提供する
        「MentalGPT」（以下「本サービス」）の利用条件を定めるものです。ユーザーは本規約に同意の上、本サービスを利用するものとします。
      </p>

      <h2>第1条（適用）</h2>
      <p>本規約は、ユーザーと当オフィスとの間の本サービスの利用に関わる一切の関係に適用されます。</p>

      <h2>（AIサービスの利用）</h2>
      <p>
        本サービスは、OpenAI が提供する API（ChatGPT）を通じてAI応答を生成します。
        生成結果は必ずしも正確性・完全性を保証するものではありません。重要事項の判断は専門家にご相談ください。
      </p>

      <h2>第2条（禁止事項）</h2>
      <ul>
        <li>法令または公序良俗に違反する行為</li>
        <li>他者の権利・利益を侵害する行為</li>
        <li>当オフィスの運営を妨害する行為</li>
      </ul>

      <h2>第3条（免責事項：医療行為ではありません）</h2>
      <p>
        本サービスはAIによる対話を通じてユーザーの気持ちに寄り添うことを目的とするものであり、
        医療行為、診断、治療を行うものではありません。専門家（医師、カウンセラー等）の支援の代替にはなりません。
        心身の健康に関する深刻な不調を感じる場合は、医療機関や専門機関にご相談ください。
      </p>

      <h2>第4条（料金・決済・解約）</h2>
      <p>料金、支払方法、解約方法は料金ページに定めます。サブスクリプションは月単位で自動更新されます。</p>

      <h2>第5条（規約の変更）</h2>
      <p>当オフィスは、必要に応じ、相当の方法でユーザーに通知の上、本規約を変更できるものとします。</p>

      <p className="date">制定：2025年8月31日 / 最終更新：2025年8月31日</p>
    </main>
  );
}